/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from '../../framework/API/api'
import { Form, FormElement } from "@progress/kendo-react-form";
import { ENTITYNAME } from "../../framework/constant/constant";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MediaEpisodeSynopsisEditForm from "./MediaEpisodeSynopsisEditForm";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import MediaEpisodeCastAndCrewEditForm from "./MediaEpisodeCastAndCrewEditForm";
import { useTranslation } from "../../locale/useTranslation";
import DynamicFieldsTab from "./DynamicFieldsTab";
import AudioTrack from "./AudioTrack";
import MediaEpisodeCensorshipDetailsEditForm from "./MediaEpisodeCensorshipDetailsEditForm";
import PgRatingEditForm from "../masters/PgRatingEditForm";
import CensorRatingEditForm from "../masters/CensorRatingEditForm";
import LanguageEditForm from "../masters/LanguageEditForm";
import { ConfirmAlert } from "../../ConfirmAlert";
import ContentTreeViewForm from "./contentTreeView/ContentTreeViewForm";
import BossDialog from "../../components/BossDialog";
import MediaExtensionEditForm from "./MediaExtensionEditForm";

function MediaEpisodeMataDataEditForm(props) {

  let isFromMusicForm = props?.isFromMusicForm ?? false;
  const lang = useTranslation();

  const [pgRatings, setPGRatings] = useState([]);
  const [censorRatings, setCensorRatings] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [mediaTechnicalPrototypes, setMediaTechnicalPrototypes] = useState([]);
  const [synopsisData, setSynopsisData] = useState(props.metaData?.Synopsis ?? []);
  const [castAndCrewData, setCastAndCrewData] = useState(props.metaData?.CastAndCrew ?? []);
  const [tabNumber, setTabNumber] = React.useState(props?.tabNumber ?? "1");
  const [audioTrackData, setAudioTrackData] = useState(props.metaData?.AudioTrack ?? []);
  const [dynamicFieldData, setDynamicFieldData] = useState(props.metaData?.dynamicField ?? {});
  const [dataItem, setDataItem] = useState(props?.metaData ?? {});
  const [censorshipDetailData, setCensorshipDetails] = useState(props.metaData?.CensorshipDetail ?? []);
  const [showContentCategory, setShowContentCategory] = useState(false);
  const [showEditForm, setShowEditForm] = useState({ pgRating: false, censorRating: false, language: false });
  const [extensionData, setExtensionData] = useState(props.metaData?.Extension ?? {});

  useEffect(() => {
    loadCombo();
  }, [props.language, props.metaData, props.SID]);

  useEffect(() => {
    if (props.SID > 0 && !props.metaData.hasOwnProperty('_id')) {
      loadEditData();
    } else {
      setSynopsisData(props.metaData?.Synopsis);
      setCastAndCrewData(props.metaData?.CastAndCrew);
      setAudioTrackData(props.metaData?.AudioTrack);
      setDynamicFieldData(props.metaData?.dynamicField);
      setCensorshipDetails(props.metaData?.CensorshipDetail);
      setExtensionData(props.metaData?.Extension);
      setDataItem(props?.metaData);
    }
  }, [props.metaData, props.SID]);

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const loadCombo = async () => {
    let pgRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    let crRes = await API.getDataLookup(ENTITYNAME.CensorRating, { sort: { Description: 1 } });
    let categories = await API.getDataLookup(ENTITYNAME.ContentCategory, { sort: { Name: 1 } });
    setCategories(categories.data);
    if (props?.language && Object.keys(props?.language)?.length > 0) {
      //SHOW MASTER DATA WHICH HAVE LANGUAGE OR WITHOUT LANGUAGE
      setPGRatings(pgRes.data.filter((x) => !x.Language || Object.keys(x.Language).length == 0 || x?.Language?._id == props?.language?._id));
      setCensorRatings(crRes.data.filter((x) => !x.Language || Object.keys(x.Language).length == 0 || x?.Language?._id == props?.language?._id));
      setCategories(categories.data.filter((x) => !x.Language || Object.keys(x.Language).length == 0 || x?.Language?._id == props?.language?._id));
    } else {
      setPGRatings(pgRes.data);
      setCensorRatings(crRes.data);
      setCategories(categories.data);
    }
    let mtpRes = await API.getDataLookup(ENTITYNAME.MediaTechnicalPrototype, { sort: { Description: 1 } });
    setMediaTechnicalPrototypes(mtpRes.data);
    let languages = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(languages.data);
  }

  const onChange = (e) => {

    console.log({ ...dataItem, [e.target.name]: e.target.value })
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    props.getMetaData({
      ...dataItem,
      [e.target.name]: e.target.value,
      Synopsis: synopsisData,
      CastAndCrew: castAndCrewData,
      AudioTrack: audioTrackData,
      dynamicField: dynamicFieldData,
      CensorshipDetail: censorshipDetailData,
      Extension: extensionData
    });
    // setMetaDataInMainObject();
  }

  const loadEditData = async () => {

    console.log("loadEditData");

    var res = await API.getData(ENTITYNAME.MediaEpisodeMetaData, { query: ['MediaEpisodeSID', '=', parseInt(props.SID)] });
    if (res.success) {
      if (res.data.length > 0 && res.data[0] != undefined) {
        setDataItem({ ...res.data[0] });
        setSynopsisData(res.data[0].Synopsis ?? []);
        setCastAndCrewData(res.data[0].CastAndCrew ?? []);
        setAudioTrackData(res.data[0].AudioTrack ?? []);
        setDynamicFieldData(res.data[0].dynamicField ?? []);
        setCensorshipDetails(res.data[0].CensorshipDetail ?? []);
        setExtensionData(res.data[0].Extension ?? {});

        const saveData = {
          ...res.data[0],
          Synopsis: res.data[0]?.Synopsis,
          CastAndCrew: res.data[0]?.CastAndCrew,
          AudioTrack: res.data[0]?.AudioTrack,
          dynamicField: res.data[0]?.dynamicField,
          CensorshipDetail: res.data[0]?.CensorshipDetail,
          Extension: res.data[0]?.Extension
        }

        props.getMetaData(saveData);
      }

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  //not using now
  const setMetaDataInMainObject = (synopsis = synopsisData, castAndCrew = castAndCrewData, audioTrack = audioTrackData, dynamicField = dynamicFieldData, censorshipDetail = censorshipDetailData, extension = extensionData) => {

    const saveData = {
      ...dataItem,
      Languages: dataItem.Languages && dataItem.Languages.length > 0 ? dataItem.Languages?.map((item) => {
        return {
          _id: item._id,
          SID: item.SID,
          Description: item.Description,
          ISOCode: item?.ISOCode
        }
      }) : [],
      PGRating: dataItem.PGRating && Object.keys(dataItem.PGRating).length > 0 ? {
        _id: dataItem.PGRating._id,
        SID: dataItem.PGRating.SID,
        Description: dataItem.PGRating.Description
      } : {},
      CensorRating: dataItem.CensorRating && Object.keys(dataItem.CensorRating).length > 0 ? {
        _id: dataItem.CensorRating._id,
        SID: dataItem.CensorRating.SID,
        Description: dataItem.CensorRating.Description
      } : {},
      MediaTechnicalPrototype: dataItem.MediaTechnicalPrototype && Object.keys(dataItem.MediaTechnicalPrototype).length > 0 ? {
        _id: dataItem.MediaTechnicalPrototype._id,
        SID: dataItem.MediaTechnicalPrototype.SID,
        Description: dataItem.MediaTechnicalPrototype.Description
      } : {},
      Categories: dataItem.Categories && dataItem.Categories.length > 0 ? dataItem.Categories?.map((item) => {
        return {
          _id: item._id,
          SID: item.SID,
          Name: item.Name,
          parent: item.parent
        }
      }) : [],
      ProductionYear: dataItem.ProductionYear,
      Synopsis: synopsis,
      CastAndCrew: castAndCrew,
      // AudioTrack: audioTrack,
      dynamicField: dynamicField,
      // CensorshipDetail: censorshipDetail,
      Extension: extension,
      DubbedLanguages: dataItem.DubbedLanguages && dataItem.DubbedLanguages.length > 0 ? dataItem.DubbedLanguages?.map((item) => {
        return {
          _id: item._id,
          SID: item.SID,
          Description: item.Description,
          ISOCode: item?.ISOCode
        }
      }) : []
    }
    console.log(saveData);
    props.getMetaData(saveData);
    props.expand && props.expand(true);
  }

  const setSynopsis = (data) => {
    setSynopsisData(() => data)
    setMetaDataInMainObject(data, castAndCrewData, audioTrackData, dynamicFieldData, censorshipDetailData, extensionData);
  }

  const setCastAndCrew = (data) => {
    setCastAndCrewData(() => data);
    setMetaDataInMainObject(synopsisData, data, audioTrackData, dynamicFieldData, censorshipDetailData, extensionData);
  }

  const setAudioTrack = (data) => {
    setAudioTrackData(() => data);
    setMetaDataInMainObject(synopsisData, castAndCrewData, data, dynamicFieldData, censorshipDetailData, extensionData);
  }

  const setDynamicField = (data) => {
    setDynamicFieldData(() => data);
    setMetaDataInMainObject(synopsisData, castAndCrewData, audioTrackData, data, censorshipDetailData, extensionData);
  }

  const setCensorshipDetailData = (data) => {
    setCensorshipDetails(() => data);
    setMetaDataInMainObject(synopsisData, castAndCrewData, audioTrackData, dynamicFieldData, data, extensionData);
  }

  const onSaveExtension = (data) => {
    console.log(data)
    setExtensionData(() => data);
    setMetaDataInMainObject(synopsisData, castAndCrewData, audioTrackData, dynamicFieldData, censorshipDetailData, data);
  }

  const handleSelectedCategories = (categories = []) => {
    if (!Array.isArray(categories) || categories.length === 0) return;

    const existingList = dataItem?.Categories || [];
    const newOnes = categories.filter(
      (cat) => !existingList.some((c) => c?._id === cat?._id)
    );
    if (newOnes.length > 0) {
      setDataItem((prev) => ({
        ...prev,
        Categories: [...(prev?.Categories || []), ...newOnes]
      }));
      props.getMetaData({
        ...dataItem,
        Categories: [...(dataItem?.Categories || []), ...newOnes],
        Synopsis: synopsisData,
        CastAndCrew: castAndCrewData,
        AudioTrack: audioTrackData,
        dynamicField: dynamicFieldData,
        CensorshipDetail: censorshipDetailData,
        Extension: extensionData
      });
    }
  };

  return (
    <div>
      <Form
        render={(formRenderProps) => (
          <FormElement>
            <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px" }}>
              <div className="row" style={{ margin: "0px" }}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={tabNumber}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleTabChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto">
                        <Tab label={lang.general_label} value="1" />
                        {!isFromMusicForm && <Tab label={lang.synopsis_label} value="2" />}
                        <Tab label={lang.cast_and_crew_label} value="3" />
                        {!isFromMusicForm && <Tab label={lang.dynamic_fields_label} value="4" />}
                        {/* {!isFromMusicForm && <Tab label={lang.audio_track_label} value="5" />} */}
                        {/* {!isFromMusicForm && <Tab label={lang.censorship_details_label} value="6" />} */}
                        {!isFromMusicForm && <Tab label={lang.extension_label} value="7" />}
                      </TabList>
                    </Box>
                    <TabPanel value={"1"}>
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label>{lang.pg_rating_label}</label>
                            <div className="d-flex">
                              <DropDownList
                                style={{ backgroundColor: "white", flex: 1, marginRight: "10px" }}
                                data={pgRatings}
                                name="PGRating"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.PGRating}
                                onChange={onChange}
                              />
                              <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary ms-2"
                                onClick={() => setShowEditForm({ ...showEditForm, pgRating: true })}
                              >
                                <i className="fa-solid fa-plus fa-xs"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.technical_prototype_label}</label>
                            <DropDownList
                              style={{ backgroundColor: "white", width: "100%", marginRight: "10px" }}
                              data={mediaTechnicalPrototypes}
                              name="MediaTechnicalPrototype"
                              textField="Description"
                              dataItemKey="_id"
                              value={dataItem.MediaTechnicalPrototype}
                              onChange={onChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.censor_rating_label}</label>
                            <div className="d-flex">
                              <DropDownList
                                style={{ backgroundColor: "white", flex: 1, marginRight: "10px" }}
                                data={censorRatings}
                                name="CensorRating"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.CensorRating}
                                onChange={onChange}
                              />
                              <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary ms-2"
                                onClick={() => setShowEditForm({ ...showEditForm, censorRating: true })}
                              >
                                <i className="fa-solid fa-plus fa-xs"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.production_year_label}</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="ProductionYear"
                              value={dataItem.ProductionYear}
                              onChange={onChange}
                              required
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.languages_label}</label>
                            <div className="d-flex">
                              <MultiSelect
                                data={languages}
                                dataItemKey="_id"
                                textField="Description"
                                value={dataItem.Languages}
                                onChange={onChange}
                                name="Languages"
                                style={{ flex: 1, marginRight: "10px" }}
                              />
                              <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary ms-2"
                                style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                onClick={() => setShowEditForm({ ...showEditForm, language: true })}
                              >
                                <i className="fa-solid fa-plus fa-xs"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.dubbed_languages_label}</label>
                            <div className="d-flex">
                              <MultiSelect
                                data={languages}
                                dataItemKey="_id"
                                textField="Description"
                                value={dataItem.DubbedLanguages}
                                onChange={onChange}
                                name="DubbedLanguages"
                                style={{ flex: 1, marginRight: "10px" }}
                              />
                              <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary ms-2"
                                style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                onClick={() => setShowEditForm({ ...showEditForm, language: true })}
                              >
                                <i className="fa-solid fa-plus fa-xs"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.categories_label}</label>
                            <div className="d-flex">
                              <MultiSelect
                                dataItemKey="_id"
                                data={categories}
                                textField="Name"
                                value={dataItem.Categories}
                                onChange={onChange}
                                name="Categories"
                                style={{ flex: 1, marginRight: "10px" }}
                              />
                              <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                                style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                onClick={() => setShowContentCategory(true)}
                                title={lang.attech_media_category_button_tooltip}
                              >
                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.keywords_label}</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="Keywords"
                              value={dataItem.Keywords}
                              onChange={onChange}
                              required
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>{lang.mamID_label}</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="MamID"
                              value={dataItem.MamID}
                              onChange={onChange}
                              disabled
                              required
                            />
                          </div>
                        </div>
                      </div>

                    </TabPanel>
                    {!isFromMusicForm && <TabPanel value={"2"}>
                      <MediaEpisodeSynopsisEditForm data={synopsisData ?? []} setSynopsisData={setSynopsis} mediaData={props?.mediaData} />
                    </TabPanel>}
                    <TabPanel value={"3"}>
                      <MediaEpisodeCastAndCrewEditForm language={props?.language ?? {}} mediaData={props?.mediaData} data={castAndCrewData ?? []} setCastAndCrew={setCastAndCrew} />
                    </TabPanel>
                    {!isFromMusicForm && <TabPanel value={"4"}>
                      <DynamicFieldsTab dataItem={dynamicFieldData} setDynamicFieldData={setDynamicField} />
                    </TabPanel>}
                    {!isFromMusicForm && <TabPanel value={"5"}>
                      <AudioTrack data={audioTrackData ?? []} setAudioTrackData={setAudioTrack} />
                    </TabPanel>}
                    {!isFromMusicForm && <TabPanel value={"6"}>
                      <MediaEpisodeCensorshipDetailsEditForm data={censorshipDetailData ?? []} setCensorshipDetailData={setCensorshipDetailData} />
                    </TabPanel>}
                    {!isFromMusicForm && <TabPanel value={"7"}>
                      <MediaExtensionEditForm item={extensionData} onChangeExtensionData={onSaveExtension} />
                    </TabPanel>}
                  </TabContext>
                </Box>
              </div>
            </div>
            {showEditForm.pgRating && <PgRatingEditForm item={{ Language: props.language }} cancelEdit={() => setShowEditForm({ ...showEditForm, pgRating: false })} refresh={() => loadCombo()} />}
            {showEditForm.censorRating && <CensorRatingEditForm item={{ Language: props.language }} cancelEdit={() => setShowEditForm({ ...showEditForm, censorRating: false })} refresh={() => loadCombo()} />}
            {showEditForm.language && <LanguageEditForm item={{ Language: props.language }} cancelEdit={() => setShowEditForm({ ...showEditForm, language: false })} refresh={() => loadCombo()} />}
            {showContentCategory &&
              <BossDialog width="50vh" title={lang.add_content_category_label} onClose={() => setShowContentCategory(false)}>
                <ContentTreeViewForm isSaveButton={true} isMultiSelect={true} onClose={() => setShowContentCategory(false)} handleSelectedCategories={handleSelectedCategories} />
              </BossDialog>}
          </FormElement>
        )} />
    </div>
  )
}

export default MediaEpisodeMataDataEditForm
